import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UtilService } from '@services/index';

import { MatDialogRef } from '@angular/material/dialog';
import { AuthService as AuthentificationService, OrganismeConnexion } from '@estel-numerique/galaclick-api';
import { CacheLowService } from '@estel-numerique/galaclick-core';
import { lastValueFrom } from 'rxjs';
import { DialogGalaComponent } from '../../composants/dialog-gala/dialog-gala.component';
import { InputGala } from '../../composants/inputs/input.component';
import { MatButton } from '@angular/material/button';
import { TranslateService } from '@ngx-translate/core';

@Component({
    templateUrl: './mdp-oublie.component.html',
    imports: [DialogGalaComponent, FormsModule, ReactiveFormsModule, InputGala, MatButton]
})
export class MdpOublieComponent implements OnInit {
    private util = inject(UtilService);
    public wsAuth = inject(AuthentificationService);
    private formBuilder = inject(FormBuilder);
    public translate = inject(TranslateService);
    protected wsCacheLow = inject(CacheLowService);
    private dialogRef = inject<MatDialogRef<MdpOublieComponent>>(MatDialogRef);

    public titre = "";
    public codeModule: string = null; // Code module/option testé pour vérifier l'accès à cette fonction (si null = OK)
    protected lgTrad: Record<string, string>;

    public formOubli = this.formBuilder.group({
        LOGIN: ['', Validators.required],
        MAIL: ['', [Validators.required, Validators.email]],
    });

    public listeOrga: OrganismeConnexion[];
    ngOnInit() {
        this.lgTrad = {
            LOGIN: this.translate.instant("LOGIN"),
            PASSWORD: this.translate.instant("PASSWORD"),
            MAIL: this.translate.instant('MAIL'),
            ENR: this.translate.instant("ENRMIN"),
            RET: this.translate.instant("RET"),
            SIGNIN: this.translate.instant("SIGNIN"),
            MDPOUBLI: this.translate.instant("MESSAGE.MDPOUBLI")
        };
    }

    hideModalOubli(force?: boolean) {
        if (force || !this.formOubli.untouched) {
            this.resetFormOubli();
            this.dialogRef.close();
        } else {
            this.util.fConfirm(this.translate.instant("QUITNOSAVE"), () => { this.hideModalOubli(true); }, this.translate.instant("MODIFDONE"));
        }
    }

    resetFormOubli() {
        this.formOubli.reset();
        this.formOubli.markAsUntouched();
    }

    async getMailFromWS() {
        this.util.showLoader();
        this.formOubli.markAllAsTouched();
        if (this.formOubli.valid) {
            const login = this.formOubli.get("LOGIN").value.toUpperCase();
            const mail = this.formOubli.get("MAIL").value;
            try {
                await lastValueFrom(this.wsAuth.getMdpOubli(login, mail));
                this.hideModalOubli(true);
                this.util.fInfo(this.translate.instant("MESSAGE.MDPCHANGE") + " " + mail);
            } catch (e) {
                this.util.fErreur(e);
            }
        }
        this.util.hideLoader();
    }
}

